import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import ExploreIcon from '@material-ui/icons/Explore';
import { exploreRouteRef } from './routes';

const explorePage = PageBlueprint.make({
  params: {
    path: '/explore',
    title: 'Explore',
    icon: <ExploreIcon fontSize="inherit" />,
    routeRef: exploreRouteRef,
    loader: () => import('./components').then(m => <m.EssityExplorePage />),
  },
});

export const essityExploreMenuPlugin = createFrontendPlugin({
  pluginId: 'essity-explore-menu',
  title: 'Explore',
  icon: <ExploreIcon fontSize="inherit" />,
  extensions: [explorePage],
  routes: { root: exploreRouteRef },
});
